import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  MenuItem,
  Typography,
  Paper,
} from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { enqueueSnackbar } from "notistack";
import {
  createCodesAPIEndpoint,
  EndPoints,
} from "./../../../../services/CodeAPI";
import { LocationOnOutlined } from "@mui/icons-material";

function GenerateCodes({ lessons }) {
  const [selectedLesson, setSelectedLesson] = useState("");
  const [numCodes, setNumCodes] = useState("");
  const [generatedCodes, setGeneratedCodes] = useState([]);
  const [loading, setLoading] = useState(false);
  const handleGenerate = () => {
    setLoading(true);
    if (!selectedLesson || !numCodes) {
      enqueueSnackbar("Please select a lesson and enter number of codes.", {
        variant: "warning",
      });
      return;
    }

    createCodesAPIEndpoint(EndPoints.generateCodes)
      .postById(
        `${selectedLesson}?numberOfCodes=${numCodes}`,
        {},
        {
          responseType: "blob",
        },
      )
      .then((res) => {
        const file = new Blob([res.data], {
          type: "application/pdf",
        });

        const url = window.URL.createObjectURL(file);

        const link = document.createElement("a");
        link.href = url;
        link.download = "Lesson-Codes.pdf";
        document.body.appendChild(link);
        link.click();
        link.remove();

        window.URL.revokeObjectURL(url);

        enqueueSnackbar("PDF downloaded successfully.", {
          variant: "success",
        });
      })
      .catch(() => {
        enqueueSnackbar("Failed to generate PDF.", {
          variant: "error",
        });
      }).finally(() => {
        setLoading(false);
      });
  };
  return (
    <Paper
      elevation={3}
      sx={{
        p: 4,
        maxWidth: 700,
        mx: "auto",
        mt: 4,
        borderRadius: 3,
      }}
    >
      <Typography
        variant="h4"
        sx={{
          mb: 4,
          fontWeight: 700,
          textAlign: "center",
          color: "primary.main",
        }}
      >
        Generate Lesson Codes
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 3,
        }}
      >
        {/* Lesson */}
        <TextField
          select
          fullWidth
          label="Select Lesson"
          value={selectedLesson}
          onChange={(e) => setSelectedLesson(e.target.value)}
        >
          {lessons.map((lesson) => (
            <MenuItem
              key={lesson.id}
              value={lesson.id}
              className="lesson-menu-item"
            >
              <div className="lesson-option">
                <span className="lesson-title">{lesson.title}</span>

                <span className="lesson-center">
                  <LocationOnOutlined />

                  {lesson.centerName || "No center"}
                </span>
              </div>
            </MenuItem>
          ))}
        </TextField>
        {/* Number */}
        <TextField
          type="number"
          fullWidth
          label="Number of Codes"
          value={numCodes}
          onChange={(e) => setNumCodes(e.target.value)}
          inputProps={{ min: 1 }}
        />

        {/* Generate */}
        <Button
          variant="contained"
          size="large"
          onClick={handleGenerate}
          sx={{
            py: 1.5,
            fontWeight: "bold",
            borderRadius: 2,
          }}
        >
          Generate & Download PDF
        </Button>
      </Box>

      <Box
        sx={{
          mt: 5,
          p: 2,
          borderRadius: 2,
          bgcolor: "#f5f5f5",
        }}
      >
        <Typography variant="body2" color="text.secondary">
          • The generated PDF contains printable lesson access cards.
        </Typography>

        <Typography variant="body2" color="text.secondary">
          • Each card contains a unique access code.
        </Typography>

        <Typography variant="body2" color="text.secondary">
          • Print and distribute the cards to students.
        </Typography>
      </Box>
    </Paper>
  );
}

export default GenerateCodes;
